const ChatOutlined = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.25 4.85C1.25 3.58988 1.25 2.95982 1.49524 2.47852C1.71095 2.05516 2.05516 1.71095 2.47852 1.49524C2.95982 1.25 3.58988 1.25 4.85 1.25H11.15C12.4101 1.25 13.0402 1.25 13.5215 1.49524C13.9448 1.71095 14.289 2.05516 14.5048 2.47852C14.75 2.95982 14.75 3.58988 14.75 4.85V8.9C14.75 10.1601 14.75 10.7902 14.5048 11.2715C14.289 11.6948 13.9448 12.039 13.5215 12.2548C13.0402 12.5 12.4101 12.5 11.15 12.5H9.26281C8.79477 12.5 8.56075 12.5 8.33691 12.5459C8.13832 12.5867 7.94615 12.6541 7.76561 12.7463C7.56213 12.8503 7.37939 12.9965 7.01391 13.2889L5.22482 14.7201C4.91275 14.9698 4.75672 15.0946 4.6254 15.0948C4.5112 15.0949 4.40317 15.043 4.33192 14.9537C4.25 14.8511 4.25 14.6513 4.25 14.2516V12.5C3.55252 12.5 3.20378 12.5 2.91766 12.4233C2.1412 12.2153 1.53472 11.6088 1.32667 10.8323C1.25 10.5462 1.25 10.1975 1.25 9.5V4.85Z"
      stroke="#6D28D9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChatOutlined;
